export default __webpack_public_path__ + "static/media/google-api.19490f54.svg";